import React, { useEffect } from "react";
import { useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./styles/pubcontact.css";
import Map from "../../components/Map";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import PatternDesign from "../../components/PatternDesign";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { Helmet } from "react-helmet";


const url =
  "https://docs.google.com/forms/d/e/1FAIpQLSf9HViz_WHBug5ivIox2m6wCk7GL5uEkv4lqpybsf8HaNxoSg/viewform?usp=pp_url&entry.1002355146=Aakash&entry.186226730=acashvg123@gmail.com&entry.711828188=khiladi+adda&entry.1366469530=9548327808&entry.1001224830=gooood";
const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const formData = new FormData();
      formData.append("entry.1002355146", form.name); // Replace with actual entry IDs
      formData.append("entry.186226730", form.email);
      formData.append("entry.1366469530", form.phone);
      formData.append("entry.711828188", form.company);
      formData.append("entry.1001224830", form.message);
  
      await fetch(
        "https://docs.google.com/forms/d/e/1FAIpQLSf9HViz_WHBug5ivIox2m6wCk7GL5uEkv4lqpybsf8HaNxoSg/formResponse",
        {
          method: "POST",
          mode: "no-cors", // <- this is key
          body: formData,
        }
      );
      setMessage(
        "Thanks for submitting the details, Our team will contact you soon !"
      );
      setShowAlert(true);
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong");
      setShowAlert(true);
      // alert("Error submitting lead." + error.message);
    } finally {
      setForm({
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
      });
    }
  };

  const [value, setValue] = useState();
  useEffect(() => {
    let timeOut = setTimeout(()=>{
      if(showAlert){
        setShowAlert(false)
      }
    },2000)
    window.scrollTo(0, 0);
    return()=>clearTimeout(timeOut)
  }, [showAlert]);
  return (
    <>
    <Helmet>
        <title>Contact Us - Real Opinion</title>
        <meta
          name="description"
          content="Looking to increase app revenue? RealOpinions.ai connects your users with trusted survey providers for seamless monetization and better retention."
        />
        <meta
          name="keywords"
          content="Real Opinion, Survey, Survey Wall, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Real Opinion" />
        <meta
          title="Real Opinion - Contact Us"
          content="Looking to increase app revenue? RealOpinions.ai connects your users with trusted survey providers for seamless monetization and better retention."
        />
        xs
      </Helmet>
      {showAlert && (
        <div style={{
          margin:"auto",
          maxWidth:"1180px"
          
        }}>
          <Alert  severity="success">
          {message}
        </Alert>
        </div>
        
      )}
      <PatternDesign />
      <form
        method="post"
        onSubmit={handleSubmit}
        className="container contact-container"
      >
        <h1 className="contact-heading">Get in touch</h1>
        <p className="contact-sub">
        Collaborate with us now!!
        </p>
        <br />
        <div className="input-box">
          <div className="name">
            <label htmlFor="name">Name*</label>
            <input
              type="text"
              required
              name="name"
              id=""
              value={form.name || ""}
              onChange={handleChange}
              placeholder="Enter your full name"
            />
          </div>
          <div className="email">
            <label htmlFor="email">Work Email*</label>
            <input
              type="email"
              required
              value={form.email || ""}
              name="email"
              onChange={handleChange}
              id=""
              placeholder="Enter your work email address"
            />
          </div>
        </div>
        <div className="input-box">
          <div className="phone-box">
            <label htmlFor="name">Phone*</label>
            <div className="phone">
              <PhoneInputWithCountrySelect
                className="phone-input"
                international
                readOnly
                
                value={value}
                onChange={setValue}
                defaultCountry="IN"
              />
              <input
                onChange={handleChange}
                type="number"
                name="phone"
                required
                value={form.phone || ""}
                id="phone"
                placeholder="Enter your phone number"
              />
            </div>
          </div>

          <div className="email">
            <label htmlFor="email">Company*</label>
            <input
              onChange={handleChange}
              type="text"
              name="company"
              required
              value={form.company || ""}
              id=""
              placeholder="Enter your company name "
            />
          </div>
        </div>
        <div className="message">
          <label htmlFor="message">Message*</label>
          <textarea
            name="message"
            id=""
            value={ form.message || ""}
            onChange={handleChange}
            cols="30"
            rows="6"
            placeholder="Enter your message here"
          ></textarea>
        </div>
        <div className="btn-div">
          <button type="submit" className="btn-primary btn-submit">
            Submit
          </button>
        </div>
      </form>

      {/* Begin */}
      <div className="begin-container">
        <div className="begin-image">
          <img src="images/contact.png" alt="" />
        </div>
        <div className="begin-content">
          <p className="begin-title">Get Started</p>
          <h1>Ready To Begin?</h1>
          <div className="begin-btn-div">
            <button
              className="btn-primary  btn-begin"
              onClick={() => {
                window.open("https://publisher.realopinions.ai/register");
              }}
            >
              Register As Publisher
            </button>
            <button
              className="btn-primary btn-begin"
              onClick={() => {
                window.open("https://publisher.realopinions.ai/login");
              }}
            >
              Login Now
            </button>
          </div>
        </div>
      </div>
      <Map />
    </>
  );
};

export default Contact;
